import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CheckOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import moment from "moment";

import { InputHook, SelectHook, RangePickerHook } from "components/hook-forms";
import { ClearAllIcon } from "components/svgs/ClearAllIcon";
import { selectAllClients } from "modules/admin/clients/store/clientSlice";
import { getClientList } from "modules/admin/clients/store/thunks";
import { ORDERV2_STATUS_SELECT } from "modules/client/routes/constants";

import "modules/client/routes/components/header/FilterRoute.scss";

const FilterFlexioPool = ({
  defaultValues,
  setShowFilter,
  handleClickFilter,
  onReset,
  onFilterChange
}) => {
  // Calculate default date range: first day of last month to last day of current month
  const getDefaultDateRange = () => {
    const startOfLastMonth = moment().subtract(1, "months").startOf("month");
    const endOfCurrentMonth = moment().endOf("month");
    return [startOfLastMonth, endOfCurrentMonth];
  };
  const clients = useSelector(selectAllClients);
  const dispatch = useDispatch();
  const {
    reset,
    getValues,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: "onSubmit",
    defaultValues: defaultValues
  });
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    dispatch(getClientList({ pageSize: 1000 }));
    // eslint-disable-next-line
  }, [dispatch]);

  const submitForm = async (values) => {
    onFilterChange(values);
  };

  return (
    <div className="filter-order-component">
      {contextHolder}
      <form onSubmit={handleSubmit(submitForm)}>
        <div className="wrap-form-filter">
          <InputHook
            control={control}
            placeholder="ID"
            label="ID"
            name="id"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Dropoff Contact Name"
            label="Dropoff Contact Name"
            name="dropoffContactName"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Dropoff Stop Name"
            label="Dropoff Stop Name"
            name="dropoffStopName"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Dropoff Contact Phone"
            label="Dropoff Phone"
            name="dropoffContactPhone"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />

          <RangePickerHook
            control={control}
            getValues={getValues}
            label="Pickup Date Range"
            name="pickupDateRange"
            errors={errors}
            showOptionsName={false}
          />
          <SelectHook
            mode="multiple"
            allowClear
            showOptionsName={false}
            control={control}
            getValues={getValues}
            placeholder="All"
            label="Status"
            name="status"
            valueSelect="value"
            labelSelect="name"
            required
            errors={errors}
            options={ORDERV2_STATUS_SELECT}
            defaultValue={[]}
            showSearch={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          />
          <SelectHook
            showOptionsName={false}
            control={control}
            getValues={getValues}
            placeholder="Client"
            label="Client"
            name="client_id"
            valueSelect="id"
            labelSelect="clientName"
            options={[{ clientName: "All", id: "" }, ...clients]}
            required
            errors={errors}
            showSearch={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
        <div className="wrap-button">
          <Button type="link" className="collapse" onClick={() => setShowFilter(false)}>
            Collapse <UpOutlined />
          </Button>
          <Button
            type="link"
            className="svg-icon clear"
            onClick={() => {
              reset({ pickupDateRange: getDefaultDateRange() });
              onReset();
            }}
          >
            Clear <ClearAllIcon />
          </Button>
          <Button type="primary" htmlType="submit">
            Apply <CheckOutlined />
          </Button>
        </div>
      </form>
    </div>
  );
};
export default FilterFlexioPool;
